export default {
    textPrincipal: 'Ao continuar a usar este site, você concorda com o uso de cookies de acordo com nossas ',
    conditions: 'Condições-Gerais',
    path: 'condicoes-gerais',
}